export default __webpack_public_path__ + "static/media/Cash_Free_Excel_File_Preveiw.ca462063.png";